
import { TGenericObject } from '@/types/base'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Reversions extends Vue {
  @Prop({ required: true }) fieldName!: string
  @Prop({ default: 5 }) limit!: number
  @Prop({ required: true }) apiUrl!: string

  changes: TGenericObject[] = []
  loading = false

  async mounted(): Promise<void> {
    this.fetchChanges()
  }

  async fetchChanges(): Promise<void> {
    this.loading = true
    try {
      const url = `${this.apiUrl}/field-changes/?field=${this.fieldName}&limit=${this.limit}`
      const res = await fetch(url)
      if (res.ok) {
        this.changes = await res.json()
      } else {
        this.changes = []
      }
    } catch (e) {
      this.changes = []
    }
    this.loading = false
  }

  formatDate(dateStr: string) {
    const d = new Date(dateStr)
    return d.toLocaleString()
  }
}
